import {
  requestService,
  useRequestPersistedStore,
  useRequestStore,
} from "entities/Request";
import { getRedirectRoute } from "entities/Request/utils/getRedirectRoute";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "shared/ui";

export default function WithdrawRequestModal({
  show,
  handleClose,
  updateLoadingState,
  isWithdrawing,
}) {
  const { t } = useTranslation("Request");
  const navigate = useNavigate();
  const request = useRequestStore((state) => state.request);
  const viewRequestAs = useRequestPersistedStore(
    (state) => state.viewRequestAs
  );

  const withdrawRequest = () => {
    updateLoadingState({ isWithdrawing: true });
    requestService
      .withdrawRequest(viewRequestAs.role, request?.id, {
        onSuccess: t("toasts.request_withdrawn", { ns: "Request" }),
      })
      .then(() => {
        navigate(getRedirectRoute(viewRequestAs.role, request?.type));
      })
      .finally(() => updateLoadingState({ isWithdrawing: false }));
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("withdraw_request_modal_title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t("request_withdrawal_confirmation")}</Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button variant="outline-primary" onClick={handleClose}>
          {t("buttons.cancel")}
        </Button>
        <Button
          variant="primary"
          onClick={withdrawRequest}
          disabled={isWithdrawing}
          isLoading={isWithdrawing}
        >
          {t("buttons.withdraw")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
